"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DimensionEnum = void 0;
/** 计量量纲类型 */
var DimensionEnum;
(function (DimensionEnum) {
    /** 时长类 */
    DimensionEnum["Duration"] = "Duration";
    /** 容量类 */
    DimensionEnum["Capacity"] = "Capacity";
    /** 流量类 */
    DimensionEnum["Flow"] = "Flow";
    /** 带宽类 */
    DimensionEnum["Bandwidth"] = "Bandwidth";
    /** 计数类 */
    DimensionEnum["Count"] = "Count";
    /** 频率类 */
    DimensionEnum["Frequency"] = "Frequency";
    /** 无量纲（适用于私有云买断场景） */
    DimensionEnum["None"] = "None";
    /** 资源占用 */
    DimensionEnum["ResourceOccupied"] = "ResourceOccupied";
})(DimensionEnum || (exports.DimensionEnum = DimensionEnum = {}));
